module.exports = __webpack_public_path__ + "img/10-3.f608d0c1.png";